<template>
<el-scrollbar>
  <el-tabs v-model="tabName" class="demo-tabs" style="max-width: 1400px;margin: auto;border-left:1px solid #e5e5e5;border-right:1px solid #e5e5e5;padding:0 5px 0 5px">
    <el-tab-pane label="流程详情" name="info">
      <div class="process_info" >
        <!-- 工作流表头-->
        <div style="height:40px;line-height: 40px;font-weight: bold;">
          <el-row>
            <el-col :span="12" style="text-align: left">
              <span>{{ processData.template_name }}【</span>
              <span style="color: #00afff">{{ processData.id }}</span>
              <span >】</span>
            </el-col>
            <el-col :span="12" style="text-align: right" v-if="taskActive" >
              <FrameButton v-for="item in taskButtons" :key="item.id" :button="item" :parentData="currentTaskData" v-show="item.show"></FrameButton>
            </el-col>
          </el-row>

        </div>

        <!-- 已提交的表单展示 -->
        <div class="form_box">
          <div v-for="(formData,index) in formDataList">
            <div class="form_title" style="margin-bottom: 3px">
              <div style="margin-right: 10px;width:220px">{{ formData.node_name }}</div>
              <div style="margin-right: 10px;width:150px">{{ formData.submit_user_name }}</div>
              <div style="margin-right: 10px;width:150px">{{ formData.submit_time }}</div>

              <span style="position: absolute;right: 5px;">
                <el-button v-if="index == 0 && !expanded" icon="el-icon-plus" circle size="small" @click="expandAll(true)" ></el-button>
                <el-button v-if="index == 0 && expanded" icon="el-icon-minus" circle size="small" @click="expandAll(false)" ></el-button>
                <el-button v-if="index > 0 && !formData.expanded" icon="el-icon-arrow-down" circle size="small" @click="formData.expanded = true" ></el-button>
                <el-button v-if="index > 0 && formData.expanded" icon="el-icon-arrow-up" circle size="small" @click="formData.expanded = false" ></el-button>
              </span>
            </div>
            <FrameForm v-if="formData.is_component == false && formData.form_code_final" v-show="formData.expanded" :component-param="formData.form_code_final" :readonly="true" :key="formData.id"
                       :parent-data="formData" :init-data="formData" init-url="frameProcessService.getFormInitData"></FrameForm>

            <component
                v-if="formData.is_component == true"
                min-height="100px"
                height="100%"
                width="100%"
                :parentData="formData"
                :is="getComponent(formData.form_component_final)"
                style="border: 1px solid lightgray"
            ></component>
          </div>
        </div>

        <!-- 当前任务的提交表单 -->
        <div v-if="taskActive" class="form_title">
          <div style="margin-right: 30px">{{ processData.current_task_name }}</div>
        </div>
        <FrameForm
            :component-param="currentTaskForm"
            init-url="frameProcessService.getFormInitData"
            :auto-init="false"
            v-if="taskActive"
            ref="currentTaskForm"
            :parentData="currentTaskData"/>
      </div>
    </el-tab-pane>

    <el-tab-pane label="可视化" name="image"  v-if="oldFlow == false" >
      <!--
      <el-scrollbar>
        <div v-if="oldFlow" :id="containerId" ref="graph_container" class="graph_container"></div>
      </el-scrollbar>
      -->
      <FramePrcRender ref="prcRender" class="graph_container"></FramePrcRender>

    </el-tab-pane>
  </el-tabs>
</el-scrollbar>
</template>

<script>

import {defineAsyncComponent, markRaw} from "vue";
import {mxConstants, mxEdgeStyle, mxEvent, mxGraph} from 'mxgraph-js'
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import {nextTick} from "vue";
import FramePrcRender from "../frameTest/process/FramePrcRender";

const messages = {
  zhCn: {
    label1: '工作流类型:',
    label2: '工作流编号:',
    label3: '创建用户:',
    label4: '创建时间:',
    label5: '期望完成时间:',
    label6: '流程超时:',
    label7: '流程图',
    label8: '流程日志',
    label9: '时间',
    label10: '执行用户',
    label11: '流程节点',
    label12: '操作类型',
    check_page2: '该任务已提交过！',
    check_page1: '参数工作流任务ID为空！',
    error1: '获取表单定义信息失败，',
  },
  en: {
    label1: 'Workflow type:',
    label2: 'Workflow number:',
    label3: 'Create user:',
    label4: 'Creation time:',
    label5: 'Expected completion time:',
    label6: 'Process timed out:',
    label7: 'Flow Chart',
    label8: 'Process Logs',
    label9: 'Time',
    label10: 'Executing user',
    label11: 'Process node',
    label12: 'Type of operation',
    check_page2: 'The task has been submitted！',
    check_page1: 'The parameter Workflow task ID is empty',
    error1: 'Failed to get form definition information，',
  }
}

export default {
  name: "PrcHandle",
  i18n: {messages},
  components: {FramePrcRender, Splitpanes, Pane},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      tabName:'info',
      expanded:false,
      current_task_id: '',
      processData: {},
      formDataList: [],
      currentNodeId: '',
      logs: [],
      taskActive: true,
      currentTaskForm: '',
      currentFormIdx: 0,
      nodes: [],
      routes: [],
      graph: {},
      containerId: new Date().getTime(),
      oldFlow: false,
      taskButtons: [
        {
          "component": "button",
          "type": "primary",
          "label":"转派任务",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "prc_cmn_assign_task", "title": "转派任务", "width": 600, "height": 300},
          "show": true
        },
        {
          "component": "button",
          "type": "primary",
          "label":"流程加签",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "prc_cmn_add_task_pre", "title": "流程加签", "width": 600, "height": 300},
          "show": true
        }
      ],
    }
  },
  provide() {
    return {
      $fn: {
        reload: () => {
          this.afterBtnClick();
        }
      }
    }
  },
  computed: {
    currentTaskData(){
      return {id: this.current_task_id}
    }
  },
  methods: {
    afterBtnClick() {
      this.loadPrcTaskInfo();
      //刷新列表
      this.$fn.search();
    },
    getComponent(component) {
      return markRaw(defineAsyncComponent(() => import('@/views/applications/' + component)));
    },
    async loadPrcTaskInfo() {
      if (!this.parentData || !this.parentData.id) {
        return this.$message.error(this.$t('check_page1'));
      }

      let params = {id: this.parentData.id}
      this.processData = await this.$http('frameProcessService.getPrcTaskInfo', params)
      //重新赋值当前任务id，支持连续提交
      this.current_task_id = this.processData.current_task_id;
      console.log("this.current_task_id = " + this.current_task_id);

      this.logs = this.processData?.logs || [];
      this.taskActive = this.processData?.task_active || false;
      this.formDataList = this.processData.form_data_list;
      this.expandAll(this.formDataList.length < 4);

      //初始化任务表单
      if (this.taskActive) {
        this.currentTaskForm = this.processData.current_task_form;
        if (this.currentTaskForm) {
          this.$refs.currentTaskForm.initForm();
        }
      }

      if (this.processData?.template?.edges) {
        this.oldFlow = false

        this.$refs.prcRender.render(this.processData.template);

      } else {
        this.oldFlow = true
        await nextTick()
        this.clearImage();
        this.drawProcess(this.processData);
      }
    },
    expandAll(isExpand){
      this.expanded = isExpand
      if(this.formDataList.length == 0){
        return;
      }

      for(let i=0;i<this.formDataList.length;i++){
        this.formDataList[i].expanded = isExpand;
      }

      this.formDataList[0].expanded = true
    },
    drawProcess(processData) {
      console.log("drawProcess start...")
      if (!processData) {
        return this.$message.error(`工作流数据为空！`);
      }

      this.processData = processData;
      let templateObj = processData.template;
      this.nodes = templateObj?.nodes || [];
      this.formDataList = processData.form_data_list;

      if (this.nodes.length == 0) {
        return;
      }

      this.drawImage();
    },
    drawImage() {
      console.log("drawImage start");
      // 创建画布
      var graph = new mxGraph(this.$refs.graph_container);
      this.graph = graph;

      graph.setEnabled(false); //设置启用,就是允不允许你改变CELL的形状内容。
      graph.setVertexLabelsMovable(false);

      // 设置鼠标悬停样式
      graph.getCursorForCell = function (cell) {
        if (cell !== null && cell.isFinishNode === true) {
          return 'pointer';
        }
      };

      var style = graph.getStylesheet().getDefaultEdgeStyle();
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector; //自己拐弯的连线
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";
      graph.getView().updateStyle = true; // 动态改变样式

      var parent = graph.getDefaultParent();
      //开始更新画布
      graph.getModel().beginUpdate();


      var that = this;
      //添加点击事件
      graph.addListener(mxEvent.CLICK, function (sender, evt) {
        //console.log('click in ...');
        var e = evt.getProperty('event'); // mouse event
        var cell = evt.getProperty('cell'); // cell may be null
        if (cell != null) {
          var id = cell.id;
          that.currentNodeId = cell.id
          console.log('that.currentNodeId=' + that.currentNodeId);
          that.setCurrentForms();
          evt.consume();
        }
      });

      try {

        // 插入节点
        var nodeObjects = {}
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var id = nodeData.id;

          var style = this.getNodeStyle(nodeData);
          var cell = graph.insertVertex(parent, null, nodeData.name, nodeData.x, nodeData.y, 100, 60, style);
          cell.id = id
          cell.name = nodeData.name;
          cell.isFinishNode = nodeData.finish;
          nodeObjects[id] = cell;
        }

        //插入线条
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var routes = nodeData.routes || [];
          for (var j = 0; j < routes.length; j++) {
            var routeData = routes[j];
            var fromId = routeData.source_node;
            var toId = routeData.target_node;

            if (nodeObjects[fromId] && nodeObjects[toId]) {
              var lineStyle = this.getRouteStyle(routeData);
              var hasBreakPoints = routeData.break_points && routeData.break_points.length > 0;
              var label = routeData.label || '';
              var edge = graph.insertEdge(parent, null, label, nodeObjects[fromId], nodeObjects[toId], lineStyle);
              //设置折线点
              if (hasBreakPoints) {
                edge.geometry.points = routeData.break_points
              }
            }
          }
        }
      } finally {
        // 画布更新结束
        graph.getModel().endUpdate();
      }
    },
    clearImage() {
      //var graph = this.graph;
      //开始更新画布
      //graph.getModel().beginUpdate();
      //graph.removeCells(graph.getChildVertices(graph.getDefaultParent())); //清空画布
      //graph.getModel().endUpdate();

      document.getElementById(this.containerId).innerHTML = "";
    },
    getNodeStyle(nodeData) {
      var style = 'fontSize=14';
      if (nodeData.current) {
        style = style + ';strokeColor=orange;strokeWidth=3';
      } else if (nodeData.finish) {
        style = style + ';strokeColor=#33cc66;strokeWidth=3';
      }

      if (nodeData.disabled) {
        style = style + ';fillColor=#aaa;strokeWidth=1';
      } else if (nodeData.fill_color) {
        style = style + ';strokeWidth=1;fillColor=' + nodeData.fill_color;
      }

      if (nodeData.start || nodeData.end) {
        style = style + ';rounded=1;perimeter=ellipsePerimeter;arcSize=30';
      }

      if (nodeData.font_color) {
        style = style + ';fontColor=' + nodeData.font_color;
      }
      return style;
    },
    getRouteStyle(routeData) {
      var normalStyle = 'edgeStyle=elbowEdgeStyle;';
      var activeStyle = 'edgeStyle=elbowEdgeStyle;strokeWidth=3;strokeColor=#33cc66';
      var lineStyle = normalStyle;
      if (routeData.finish) {
        lineStyle = activeStyle;
      } else if (routeData.color) {
        lineStyle = normalStyle + "strokeColor=" + routeData.color;
      }
      return lineStyle;
    }

  },
  mounted() {
    this.loadPrcTaskInfo();
  }
}
</script>

<style lang="less" scoped>

.splitpanes__pane {
  background-color: white !important;
}

.splitpanes__splitter {
  background-color: whitesmoke !important;
}

.graph_container {
  background-color: white;
  height: 100%;
}

.form_switch_toolbar {
  display: inline-flex;
  padding: 5px;
}

.form_switch_button {
  display: inline-block;
  margin-right: -2px;
}

.form_switch_button_active {
  display: inline-block;
  margin-right: -2px;
  border-color: #0a84ff;
}

.form_title {
  background-color: whitesmoke;
  border: 1px solid #e5e5e5;
  height: 30px;
  line-height: 30px;
  padding-left: 30px;
  margin-top: -1px;
  width: 100%;
  display: inline-flex;
}

</style>
